import { BaseModel } from '../core/abstractions/base.model';
import { SearchItemModel } from './search-item.model';

export class SearchGroupModel extends BaseModel {
    groupType: string;
    groupName: string;
    items: SearchItemModel[] = [];

    constructor(init: Partial<SearchGroupModel>) {
        super();
        Object.assign(this, init);
    }
}
